import React from 'react';
import { OrbitControls } from '@react-three/drei';

/**
 * Wraps OrbitControls with fully configurable props.
 * Damping is always enabled for smooth feel (factor 0.05).
 * `makeDefault` registers controls with R3F's internal state.
 */
function ViewerControls({
  autoRotate = true,
  autoRotateSpeed = 0.5,
  enableZoom = true,
  enablePan = false,
  enableRotate = true,
  minDistance = 2,
  maxDistance = 40,
  minPolarAngle = Math.PI / 6,
  maxPolarAngle = Math.PI / 2.5,
}) {
  return (
    <OrbitControls
      makeDefault
      autoRotate={autoRotate}
      autoRotateSpeed={autoRotateSpeed}
      enableZoom={enableZoom}
      enablePan={enablePan}
      enableRotate={enableRotate}
      minDistance={minDistance}
      maxDistance={maxDistance}
      minPolarAngle={minPolarAngle}
      maxPolarAngle={maxPolarAngle}
      enableDamping
      dampingFactor={0.05}
    />
  );
}

export default ViewerControls;
